import LArtwork from "@components/LArtwork";
import LBox from "@components/LBox";
import LIcon from "@components/LIcon";
import LPressable from "@components/LPressable";
import LText from "@components/LText";
import type { SupportedArtistSong } from "./inboxPlayback";

export const SupportedArtistSongs = ({
  isLoading,
  recommendations,
  onPlay,
}: {
  isLoading: boolean;
  recommendations: SupportedArtistSong[];
  onPlay: (recommendation: SupportedArtistSong) => void;
}) => {
  if (!isLoading && recommendations.length === 0) return null;

  return (
    <LBox gap="s3">
      <LText variant="Heading/H2/SemiBold">Play their music</LText>

      {recommendations.map((recommendation) => (
        <LPressable
          accessibilityHint="Starts this song"
          accessibilityLabel={`Play ${recommendation.song.title} by ${recommendation.artist.name}`}
          accessibilityRole="button"
          fadeEnabled
          key={recommendation.artist.id}
          onPress={() => onPlay(recommendation)}
          sentryEventName="inbox_supported_artist_song_press"
        >
          <LBox alignItems="center" flexDirection="row" gap="s3" py="s1">
            <LArtwork
              borderRadius="m"
              size={48}
              url={recommendation.song.albums.at(0)?.image}
            />
            <LBox flex={1} gap="s0_5">
              <LText numberOfLines={1} variant="Body/B1/Medium">
                {recommendation.song.title}
              </LText>
              <LText color="subGrey" numberOfLines={1} variant="Body/B2/Medium">
                {recommendation.artist.name}
              </LText>
            </LBox>
            <LBox
              alignItems="center"
              backgroundColor="whiteTranslucent10"
              borderRadius="max"
              height={36}
              justifyContent="center"
              width={36}
            >
              <LIcon name="play" size={14} />
            </LBox>
          </LBox>
        </LPressable>
      ))}

      {isLoading && recommendations.length === 0 ? (
        <LText color="subGrey" variant="Body/B2/Regular">
          Finding songs from these artists…
        </LText>
      ) : null}
    </LBox>
  );
};
